import { render, staticRenderFns } from "./liveItem.vue?vue&type=template&id=b9159630&scoped=true&"
import script from "./liveItem.vue?vue&type=script&lang=js&"
export * from "./liveItem.vue?vue&type=script&lang=js&"
import style0 from "./liveItem.vue?vue&type=style&index=0&id=b9159630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9159630",
  null
  
)

export default component.exports